import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: #fffcf6;
  border: 1px solid #ed9500;
  border-radius: 8px;
  padding: 16px 10px;
  display: flex;
  align-items: center;
  gap: 26px;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Text = styled.span`
  font-family: "Mangueira", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #3d3d3d;
`;

export const Title = styled(Text)`
  font-weight: 700;
`;
